<template>
  <v-snackbar
    absolute
    top
    v-model="active"
    multi-line
    :color="color"
    :timeout="timeout">
    <v-icon v-if="icon" left color="white">{{ icon }}</v-icon>
    {{ $vuetify.lang.t(text) }}
    <v-btn
      color="white"
      text
      @click="active = false"
    >
      {{ $vuetify.lang.t('$vuetify.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>

import { createHelpers } from 'vuex-map-fields'
import { SNACKBAR_MODULE } from '../../store/modules'
//
const { mapFields } = createHelpers({
  getterType: `${SNACKBAR_MODULE}/getField`,
  mutationType: `${SNACKBAR_MODULE}/updateField`
})

export default {
  name: 'messageSnackbar',
  computed: {
    ...mapFields(['active', 'text', 'timeout', 'color', 'icon'])
  }
}
</script>

<style scoped>
  .v-snack {
    z-index: 10000 !important;
  }
</style>
